import { inject, Injectable } from '@angular/core';
import { NonNullableFormBuilder, Validators } from '@angular/forms';

import type { DefineFormData, UnwrapSignal } from '@tellent-ask-hr/dynamic-forms-types';

@Injectable({ providedIn: 'root' })
export class QuestionService {
  private readonly formBuilder = inject(NonNullableFormBuilder);

  public readonly createQuestionForm = (
    data?: DefineFormData,
  ): UnwrapSignal<import('./question.component').QuestionComponent['defineForm']> =>
    this.formBuilder.group({
      question: this.formBuilder.control(<string>data?.value?.question ?? '', Validators.required),
      hint: this.formBuilder.control(<string>data?.value?.hint ?? ''),
      required: this.formBuilder.control(<boolean>data?.value?.required ?? true),
    });
}
